<template>
    <div>
        <b-modal
          :show="isModalVisible"
          :no-close-on-backdrop="true"
          hide-footer
                    centered
          :title="labels.title"
          :modal-class="modalCssClass"
          header-class="reset-modal-header"
          title-class="reset-modal-title"
          body-class="reset-modal-body"
          class="reset-password-dialog"
         @hide="isModalVisible">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">{{ labels.title }}</div>
                    <div class="password-policy-item">{{ labels.texto }}</div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="cancelDelete">{{ labels.cancelar }}</b-button>
                    <b-button class="reset-btn-primary" @click="confirmDelete">{{ labels.aceptar }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: 'DialogConfirm',
    props: ['InactivaItem','borraReg'],
    data: () => ({
      transitionState: "idle",
      closeTimer: null,
      openTimer: null
    }),
    computed:{
        isModalVisible() {
            return this.InactivaItem || this.transitionState === "closing"
        },
        modalCssClass() {
            const classes = ["reset-inactivate-modal"]
            if (this.isModalVisible) {
                classes.unshift("show", "d-block")
            }
            if (this.InactivaItem && this.transitionState !== "closing") {
                classes.push("modal-opening")
            }
            if (this.transitionState === "closing") {
                classes.push("closing")
            }
            return classes.join(" ")
        },
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Inactivar Registro",
                    texto : "¿Seguro desea inhabilitar este registro?",
                    aceptar : "Aceptar",
                    cancelar : "Cancelar"
                }
            }else{
                return {
                    title: "Inactivate Row",
                    texto : "Are you sure you want to inactivate this record?",
                    aceptar : "Accept",
                    cancelar : "Cancel"
                }
            }
        }
    },
    methods: {
        cancelDelete(){
            this.requestClose()
        },
        confirmDelete(){
            if (this.transitionState === "closing") return
            this.transitionState = "closing"
            this.clearCloseTimer()
            this.$emit('confirmDelete')
            this.closeTimer = setTimeout(() => {
                this.$emit('cierraModal', false)
                this.transitionState = "idle"
            }, 220)
        },
        requestClose(){
            if (this.transitionState === "closing") return
            this.transitionState = "closing"
            this.clearCloseTimer()
            this.closeTimer = setTimeout(() => {
                this.$emit('cierraModal', false);
                this.transitionState = "idle"
            }, 220)
        },
        clearCloseTimer(){
            if (this.closeTimer) {
                clearTimeout(this.closeTimer)
                this.closeTimer = null
            }
        },
        clearOpenTimer(){
            if (this.openTimer) {
                clearTimeout(this.openTimer)
                this.openTimer = null
            }
        }
    },
    watch: {
        InactivaItem(val) {
            if (val) {
                this.transitionState = "opening"
                this.clearCloseTimer()
                this.clearOpenTimer()
                this.openTimer = setTimeout(() => {
                    if (this.InactivaItem && this.transitionState === "opening") {
                        this.transitionState = "idle"
                    }
                }, 30)
            } else if (this.transitionState !== "closing") {
                this.transitionState = "idle"
                this.clearOpenTimer()
                this.clearCloseTimer()
            }
        }
    },
    beforeUnmount() {
        this.clearOpenTimer()
        this.clearCloseTimer()
    }
}
</script>
